import {
  IAutoTableProtractedExtension,
  ProtractedType,
  ProtractedFeature,
  IValue,
} from '../../model';
import { getProtractedData, setProtractedData } from './protracted';
import {
  getObject,
  setObject,
} from '../../../../lib/local-storage/interface-base';
import { IString } from '../../../table';
import { TableFontSize } from '../../../table/model';

export function getFontSizeValue<T>(source: IString<IValue>): T | undefined {
  if (Array.isArray(source.value) && source.value.length) {
    return source.value[0] || undefined;
  }
  return undefined;
}

export const setProtractedFontSizeConfigData = async (
  fontSize: TableFontSize,
  callback: (status: boolean) => void,
  protractedExtension?: IAutoTableProtractedExtension
) => {
  const config = protractedExtension
    ? protractedExtension[ProtractedFeature.fontSize]
    : null;
  if (!config) {
    return callback(false);
  }

  if (config.type === ProtractedType.remote) {
    const res = await setProtractedData(
      config.guid,
      [fontSize],
      config.remoteConfig?.setConfig
    );
    return callback(res);
  }
  // local
  const localeData = {
    key: config.guid,
    value: [fontSize],
  };
  setObject(config.guid, localeData);
  return callback(true);
};

// 查询持久化数据
export async function getProtractedFontSizeConfigData(
  callback: (data: TableFontSize | undefined) => void,
  protractedExtension?: IAutoTableProtractedExtension
) {
  const config = protractedExtension
    ? protractedExtension[ProtractedFeature.fontSize]
    : null;
  if (!config) {
    return callback(undefined);
  }
  if (config.type === ProtractedType.remote) {
    const data = await getProtractedData<ReadonlyArray<TableFontSize>>(
      config.guid,
      config.remoteConfig?.getConfig
    );
    const remoteSize =
      Array.isArray(data) && data.length
        ? getFontSizeValue<TableFontSize>(data[0])
        : undefined;
    return callback(remoteSize);
  }
  const locale = getObject<IString<IValue>>(config.guid);
  const size = getFontSizeValue<TableFontSize>(locale || {});
  return callback(size);
}
